var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.334 4.00016H14.6673V5.3335H13.334V14.0002C13.334 14.3684 13.0355 14.6668 12.6673 14.6668H3.33398C2.9658 14.6668 2.66732 14.3684 2.66732 14.0002V5.3335H1.33398V4.00016H4.66732V2.00016C4.66732 1.63198 4.9658 1.3335 5.33398 1.3335H10.6673C11.0355 1.3335 11.334 1.63198 11.334 2.00016V4.00016ZM12.0007 5.3335H4.00065V13.3335H12.0007V5.3335ZM6.00065 2.66683V4.00016H10.0007V2.66683H6.00065Z",
    fill: "#E60A2B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIcon);
export default __webpack_public_path__ + "static/media/trash-icon.5f3afdca8666aea8ccabab4f751a0442.svg";
export { ForwardRef as ReactComponent };